
      var API = require("!../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
      var domAPI = require("!../../node_modules/style-loader/dist/runtime/styleDomAPI.js");
      var insertFn = require("!../../node_modules/style-loader/dist/runtime/insertBySelector.js");
      var setAttributes = require("!../../node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js");
      var insertStyleElement = require("!../../node_modules/style-loader/dist/runtime/insertStyleElement.js");
      var styleTagTransformFn = require("!../../node_modules/style-loader/dist/runtime/styleTagTransform.js");
      var content = require("!!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./main.css");
      
      content = content.__esModule ? content.default : content;

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



module.exports = content && content.locals || {};
